export const Tenant = /** @type {const} */ ({
  // local development
  LOCAL: 'local-acme',

  // SADA - internal client for AtomAI
  DEV_SADA: 'dev-sada',
  QA_SADA: 'qa-sada',
  UAT_SADA: 'uat-sada',
  SADA: 'sada',

  // ALDOT
  DEV_ALDOT: 'dev-aldot',
  QA_ALDOT: 'qa-aldot',
  UAT_ALDOT: 'uat-aldot',
  UAT_ALDOT_DEMO: 'uat-aldot-demo',
  ALDOT: 'aldot',

  // ARDOT
  DEV_ARDOT: 'dev-ardot',
  QA_ARDOT: 'qa-ardot',
  UAT_ARDOT: 'uat-ardot',
  ARDOT: 'ardot',

  // UDOT
  DEV_UDOT: 'dev-udot',
  QA_UDOT: 'qa-udot',
  UAT_UDOT: 'uat-udot',
  UDOT: 'udot',

  // UDOT TMD (aka UDOT ITS)
  DEV_UDOT_TMD: 'dev-udot-tmd',
  QA_UDOT_TMD: 'qa-udot-tmd',
  UAT_UDOT_TMD: 'uat-udot-tmd',
  UDOT_TMD: 'udot-tmd',

  // HIDOT
  DEV_HIDOT: 'dev-hidot',
  QA_HIDOT: 'qa-hidot',
  UAT_HIDOT: 'uat-hidot',
  HIDOT: 'hidot',

  // Hennepin
  DEV_HENNEPIN: 'dev-hennepin',
  QA_HENNEPIN: 'qa-hennepin',
  UAT_HENNEPIN: 'uat-hennepin',
  HENNEPIN: 'hennepin',

  // GWRR
  DEV_GWRR: 'dev-gwrr',
  QA_GWRR: 'qa-gwrr',
  UAT_GWRR: 'uat-gwrr',
  GWRR: 'gwrr',

  // CBIT
  DEV_CBIT: 'dev-cbit',
  QA_CBIT: 'qa-cbit',
  UAT_CBIT: 'uat-cbit',
  CBIT: 'cbit',

  // SDDOT
  DEV_SDDOT: 'dev-sddot',
  QA_SDDOT: 'qa-sddot',
  UAT_SDDOT: 'uat-sddot',
  SDDOT: 'sddot',

  // Macombtownship
  DEV_MACOMB: 'dev-macombtownship',
  QA_MACOMB: 'qa-macombtownship',
  UAT_MACOMB: 'uat-macombtownship',
  MACOMB: 'macombtownship',

  // Oklahoma
  UAT_OKLAHOMA_DEMO: 'uat-oklahoma-demo',

  // MDOT
  DEV_MDOT: 'dev-mdot',
  QA_MDOT: 'qa-mdot',
  UAT_MDOT: 'uat-mdot',
  MDOT: 'mdot',

  // GDOT SigOps
  DEV_GDOT_SIGOPS: 'dev-gdot-sigops',
  QA_GDOT_SIGOPS: 'qa-gdot-sigops',
  UAT_GDOT_SIGOPS: 'uat-gdot-sigops',
  GDOT_SIGOPS: 'gdot-sigops',
  
  // OCP
  DEV_OCP: 'dev-ocp',
  QA_OCP: 'qa-ocp',
  UAT_OCP: 'uat-ocp',
  OCP: 'ocp',

  // ADOT
  DEV_ADOT: 'dev-adot',
  QA_ADOT: 'qa-adot',
  UAT_ADOT: 'uat-adot',
  ADOT: 'adot',

  // Misc UAT
  UAT_ATOM_DEMO: 'uat-atom-demo',
  UAT_DEMO: 'uat-demo',
  UAT_GDOT: 'uat-gdot',
  UAT_ITS_UDOT: 'uat-its-udot',
  UAT_LADOTD: 'uat-ladotd',
  UAT_VDOT_DEMO: 'uat-vdot-demo',
  UAT_WABTEC: 'uat-wabtec',

  // Misc Production
  COLLINS_EQUIPMENT: 'collins-equipment',
  LARIMER_COUNTY: 'larimercounty',
  MOBILE_COUNTY: 'mobilecounty',
  SCDOT: 'scdot',
});

export const Client = /** @type {const} */ ({
  LOCAL: 'LOCAL',
  ALDOT: 'ALDOT',
  ARDOT: 'ARDOT',
  GWRR: 'GWRR',
  HENNEPIN: 'HENNEPIN',
  HIDOT: 'HIDOT',
  SADA: 'SADA',
  UDOT: 'UDOT',
  CBIT: 'CBIT',
  SDDOT: 'SDDOT',
  MACOMB: 'MACOMB',
  UDOT_TMD: 'UDOT_TMD',
  MDOT: 'MDOT',
  GDOT_SIGOPS: 'GDOT_SIGOPS',
  OCP: 'OCP',
  ADOT: 'ADOT',
});

export const CLIENTS = {
  [Client.LOCAL]: [Tenant.LOCAL],
  [Client.ALDOT]: [
    Tenant.DEV_ALDOT,
    Tenant.QA_ALDOT,
    Tenant.UAT_ALDOT,
    Tenant.UAT_ALDOT_DEMO,
    Tenant.ALDOT,
  ],
  [Client.ARDOT]: [
    Tenant.DEV_ARDOT,
    Tenant.QA_ARDOT,
    Tenant.UAT_ARDOT,
    Tenant.ARDOT,
  ],
  [Client.GWRR]: [
    Tenant.DEV_GWRR,
    Tenant.QA_GWRR,
    Tenant.UAT_GWRR,
    Tenant.GWRR,
  ],
  [Client.HENNEPIN]: [
    Tenant.DEV_HENNEPIN,
    Tenant.QA_HENNEPIN,
    Tenant.UAT_HENNEPIN,
    Tenant.HENNEPIN,
  ],
  [Client.HIDOT]: [
    Tenant.DEV_HIDOT,
    Tenant.QA_HIDOT,
    Tenant.UAT_HIDOT,
    Tenant.HIDOT,
  ],
  [Client.SADA]: [
    Tenant.DEV_SADA,
    Tenant.QA_SADA,
    Tenant.UAT_SADA,
    Tenant.SADA,
  ],
  [Client.UDOT]: [
    Tenant.DEV_UDOT,
    Tenant.QA_UDOT,
    Tenant.UAT_UDOT,
    Tenant.UDOT,
  ],
  [Client.CBIT]: [
    Tenant.DEV_CBIT,
    Tenant.QA_CBIT,
    Tenant.UAT_CBIT,
    Tenant.CBIT,
  ],
  [Client.SDDOT]: [
    Tenant.DEV_SDDOT,
    Tenant.QA_SDDOT,
    Tenant.UAT_SDDOT,
    Tenant.SDDOT,
  ],
  [Client.MACOMB]: [
    Tenant.DEV_MACOMB,
    Tenant.QA_MACOMB,
    Tenant.UAT_MACOMB,
    Tenant.MACOMB,
  ],
  [Client.UDOT_TMD]: [
    Tenant.DEV_UDOT_TMD,
    Tenant.QA_UDOT_TMD,
    Tenant.UAT_UDOT_TMD,
    Tenant.UDOT_TMD,
  ],
  [Client.MDOT]: [
    Tenant.DEV_MDOT,
    Tenant.QA_MDOT,
    Tenant.UAT_MDOT,
    Tenant.MDOT,
  ],
  [Client.GDOT_SIGOPS]: [
    Tenant.DEV_GDOT_SIGOPS,
    Tenant.QA_GDOT_SIGOPS,
    Tenant.UAT_GDOT_SIGOPS,
    Tenant.GDOT_SIGOPS,
  ],
  [Client.OCP]: [
    Tenant.DEV_OCP,
    Tenant.QA_OCP,
    Tenant.UAT_OCP,
    Tenant.OCP,
  ],
  [Client.ADOT]: [
    Tenant.DEV_ADOT,
    Tenant.QA_ADOT,
    Tenant.UAT_ADOT,
    Tenant.ADOT,
  ],
};
